import { useImpersonateContext } from "@client/ImpersonateContext";
import { getEffectiveTrack, getTracksToShow } from "@engine/round/accessors";
import type { TrackStatus } from "@engine/round/aggregate";

export function useUnderlyingRoundPhases(): TrackStatus[] | null {
  const { value } = useImpersonateContext();
  if (!value) return null;
  const { round, mode, underlyingUserId } = value;
  if (!round.isSfcRound) return null;
  const roundMember = round.members[underlyingUserId];
  const effectiveTrack = getEffectiveTrack(
    { ...mode, viewAsTrackMember: null },
    roundMember,
  );
  const tracksToShow = getTracksToShow(round, roundMember, effectiveTrack);
  return tracksToShow.map((track) => round.trackSettings[track].status);
}

export function useEffectiveRoundPhases(): TrackStatus[] | null {
  const { value } = useImpersonateContext();
  if (!value) return null;
  const { round, mode, underlyingUserId } = value;
  if (!round.isSfcRound) return null;
  const actingAsUserId = mode.viewAsUserId ?? underlyingUserId;
  const roundMember = round.members[actingAsUserId];
  const effectiveTrack = getEffectiveTrack(mode, roundMember);
  const tracksToShow = getTracksToShow(round, roundMember, effectiveTrack);
  return tracksToShow.map((track) => round.trackSettings[track].status);
}
